import { useContext } from "react";
import parse from "html-react-parser";
import { string, object } from "prop-types";
import { RCLContext } from "./RCLProvider";

const RCL = ({ searchKey, replace }) => {
	const { locale, dictionary } = useContext(RCLContext);
	try {
		const item = dictionary[locale][searchKey];

		let replacedValue = item.value;
		if (replace) {
			for (let i = 0; i < Object.entries(replace).length; i++) {
				const temp = replacedValue;
				const [key, value] = Object.entries(replace)[i];
				replacedValue = temp.replace(`{{ ${key} }}`, value);
			}
		}

		if (item.parseAsMarkdown) {
			return parse(replacedValue);
		}
		return replacedValue;
	} catch {
		if (process.env.NODE_ENV === "development") {
			console.warn(`Cannot find key '${searchKey}' in the dictionary`);
		}
		return null;
	}
};

RCL.propTypes = {
	searchKey: string.isRequired,
	replace: object,
};

export default RCL;
